module.exports = __webpack_public_path__ + "img/shot_bigtx112101.8188933f.png";